import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Paper } from "@mui/material";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import { MDBContainer } from "mdb-react-ui-kit";
import BottomNavigationBar from "./BottomNavigation";
import { useDispatch, useSelector } from "react-redux";
import { addVoucherData } from "../Store/Slices/VoucherDetail";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getCurrentYearDatesISO } from "../Helper/Helper";
import { makePostRequest } from "../API";
import { BounceLoader } from "react-spinners";
import AllowHotalModal from "./reuseableComponents/Modals/AllowHotalModal";
import AllowTransportReturnModal from "./reuseableComponents/AllowTransportReturnModal";


const SingleAllowTransport = () => {
  const voucherData = useSelector((state) => state.voucherDetailSlice);
  console.log(voucherData);
  const dispatch = useDispatch();
  const [isFormVisible, setFormVisible] = useState(false);
  

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [info, setInfo] = useState(null);
  const [infoError, setInfoError] = useState(false);
  const [apiData, setApiData] = useState(2);
  const [AddToapi, setAddtoApi] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [yearError, setYearError] = useState("");

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (!token || token === "") {
  //     navigate("/login");
  //   }
  // }, [navigate]);

  const handleLogin = (event) => {
    event.preventDefault();
    setLoading(true);

    if (!info || info === "") {
      setInfoError(true);
      setLoading(false);

      return;
    }

    if (!selectedType || selectedType === "") {
      setYearError("Activity Type Is Required");
      setLoading(false);

      return;
    }


    dispatch(
      addVoucherData({
        key: selectedType,
        voucher_id: info,
      })
    );
    setInfoError(false);

    navigate("/single-allow-transport-detail");
    setLoading(false);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setAddtoApi(isExpanded ? "Added for api" : null);
    setExpanded(isExpanded ? panel : false);
  };

  const handleAccordionChange1 = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setAddtoApi(isExpanded ? "Added for api 2" : null);
  };

  console.log("this is VoucherData", voucherData);

  // console.log("infoError",infoError)
  // console.log("this is Info",info)

  const [selectedType, setSelectedType] = useState(null);

  const activityType = [
    {
      UID: "allow-hotel-activity",
      Title: " Allow Hotel",
    },
    {
      UID: "allow-transport-activity",
      Title: " Allow Transport",
    },
    {
      UID: "actual-hotel-activity",
      Title: "Actual Hotel",
    },
    {
      UID: "actual-transport-activity",
      Title: "Actual Transport",
    },
  ];

// fetching data for Grid api 
  const { firstDate, lastDate } = getCurrentYearDatesISO();
  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedActions, setSelectedActions] = useState({});
  const [sendDataToModal,setSendDataToModal]=useState(null)
  const [openReturnVoucher, setOpenReturnVoucher] = useState(false);
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    length: 100,
    start: 0,
    draw: 1,
    voucher_id: "",
    agent_country: "",
    country: "",
    agents: "",
    city: "",
    hotel: "",
    check_in_date_from: firstDate,
    check_in_date_to: lastDate,
    check_out_date_from: firstDate,
    check_out_date_to:lastDate ,
    arrival_date_from: firstDate,
    arrival_date_to: lastDate,
    checkInDateTo: null,
    return_date_from: firstDate,
    return_date_to: lastDate,
    completed: "no",
  });
  const [tableData, setTableData] = useState([]);
  const[showTable,setShowTable]= useState(null)



const fetchData = async (event,filters = null) => {


    event.preventDefault();
    setLoading(true);

    if (!info || info === "") {
      setInfoError(true);
      setLoading(false);

      return;
    }

    if (!selectedType || selectedType === "") {
      setYearError("Activity Type Is Required");
      setLoading(false);

      return;
    }


    setShowTable(true)
  const endpoint = `api/umrah/${selectedType}`;

  // Merge current state with any filters passed
  const params = {
    ...state,
    ...(filters || {}),
    length:100,
    start: 1,
    draw: 1,
  };

  try {
    setLoading(true);
    const response = await makePostRequest(endpoint, params);
    setLoading(false);

    if (response?.data?.data) {
      setTableData(response.data.data);
     
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};


// useEffect(() => {
//   fetchData(state);
// }, []);

// for expending Rows 
  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];

    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };



  const handleNavigate = (e, index) => {
    const selectedValue = e.target.value;
    setSelectedActions((prev) => ({
      ...prev,
      [index]: selectedValue, 
    }));

const [voucherId, key, record_id, param, refrance_type] =   selectedValue.split(",").map(v => v === "" ? null : v);


 
 let parsedData = {
    voucher_id: Number(voucherId),
    key: key,
    record_id: Number(record_id),
    actual_param:param,
    reference_type:refrance_type,
  };

setSendDataToModal( parsedData)



if(parsedData?.key ==="accommodation"){
   setOpenReturnVoucher(true)

}


if(parsedData?.key ==="transport"){
   setOpenReturnVoucher(true)

}





else{
  setOpen(true);
}



 };






// entry code 










  console.log("this is selected type", selectedType);
    // console.log("extra addtion to api?????????????", AddToapi);

  return (
    <>
      <div className="background-image">
        <MDBContainer breakpoint=" p-4">
          <div className="main-wrapper">
            <div>
              <div
                className="navebar"
                style={{ background: "", width: "100%", marginBottom: "20px" }}>
                <img className="logo" src={window.logo} alt="logo" />
                <Avatar
                  className="profile"
                  alt="Remy Sharp"
                  src={window.profile}
                />
              </div>

              <div style={{ marginTop: "100px" }}>
       
                <div style={{ width: "100%" }}>
                  <form className="px-2 pt-5">
                    <div>
                      <label
                        htmlFor="exampleInputEmail1"
                        className="furas-input-label px-2 fs-2"
                      >
                        Enter your Voucher Id
                      </label>
                      {/* email  */}
                      <div
                        className="email-input-icons"
                        style={{ marginBottom: "0px" }}
                      >
                        <i className="fa fa-envelope email-icon"></i>
                        <input
                          className="email-input-field bg-dark text-light custom-placeholder opacity-50"
                          style={{ borderRadius: "100px" }}
                          type="text"
                          value={info}
                          onChange={(e) => {
                            setState({ ...state, voucher_id: e.target.value })
                            setInfo(e.target.value);
                            setInfoError(false);
                          }}
                        />
                        {infoError && (
                          <div>
                            <p
                              className="text-danger f-bold"
                              style={{ marginLeft: "15px" }}
                            >
                              PLEASE ENTER YOUR VOUCHER ID TO PROCEED
                            </p>
                          </div>
                        )}
                      </div>

                      {/* type */}

                      <label
                        htmlFor="exampleInputEmail1"
                        className="furas-input-label px-2 fs-2"
                      >
                        Select Activity type
                      </label>
                      <div
                        className={` email-input-icons`}
                        style={{ paddingTop: "20px", marginBottom: "50px" }}
                      >
                        <select
                          // onClick={handleInputClick}
                          style={{ backgroundColor: "#979797", height: "44px" }}
                          className={`form-control my-login-calendar custom-placeholder  bg-dark text-light opacity-50
                        ${yearError !== "" ? "highlight" : ""}
                          
                        
                        
                        `}
                          id="Year"
                          name="Year"
                          onChange={(e) => setSelectedType(e.target.value)}
                          data-prompt-position="bottomLeft:20,35"
                          // onChange={}
                          // value={}
                          required
                        >
                          <option value="0" disabled selected>
                            Select Activity
                          </option>
                          {activityType.map((year) => (
                            <option key={year.UID} value={year.UID}>
                              {year.Title}
                            </option>
                          ))}
                        </select>
                        {yearError ? (
                          <p
                            className="text-danger f-bold"
                            style={{ marginLeft: "15px" }}
                          >
                            please select Activity
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="px-4">
                      <button
                        type="submit"
                        className="btn btn-success fs-2"
                        style={{ width: "100%", height: "40px" }}
                        onClick={fetchData}
                      >
                        {Loading ? "Searching..." : "Search"}
                      </button>
                      {/* <button
                        type="button"
                        className="Login-btn-cancel"
                        // onClick={() => setInfo('')}
                        onClick={() => {
                          navigate("/dashboard");
                        }}
                      >
                        Back
                      </button> */}
                    </div>
                  </form>





{
  showTable !== null && selectedType?.toLowerCase().split("-").includes("hotel") ?

  // hotel
  <>

    <div style={{ marginBottom: "50px" }}>
      <Paper sx={{ padding: " 10px 20px", marginTop: "10px" }}>
        <Table
          id="example"
          className="table table-striped dt-responsive nowrap table-display w-100"
        >
          {/* Table Head */}
          <TableHead>
             <TableRow>
                                   <TableCell component="th" sx={{ fontWeight: "bold" }}>
                                     Voucher
                                   </TableCell>
                                   <TableCell component="th" sx={{ fontWeight: "bold" }}>
                                     {/* Actual Hotel */}
                                     Hotel Name
                                   </TableCell>
                                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                                                   check In
                                                  </TableCell>
                                 </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {Loading ? (
              <TableRow>
                <TableCell
                  colSpan={3}
                  align="center"
                  style={{ height: "35vh" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <BounceLoader className="BouncingLoader" />
                  </div>
                </TableCell>
              </TableRow>
            )

              : tableData.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="center"
                    style={{ height: "25vh" }}
                  >
                    <h3 className="pt-5">No data found</h3>
                  </TableCell>
                </TableRow>
              ) : (
                tableData?.map((item, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                                    
                                      <TableCell
                                                            component="td"
                                                           
                                                            onClick={() => toggleExpansion(index)}
                                    
                                      sx={{
                                        cursor: "pointer",
                                        whiteSpace: "normal",   // allow text to wrap
                                        wordBreak: "break-word" // handle very long words without spaces
                                      }}
                                    
                                    
                                                          >
                                                            {/* {item?.voucher_id || "--"} */}
                                                            { item.voucher_id || "--"}
                                                          </TableCell>
                                                          <TableCell component="td">
                                                            
                                                            {item.hotel_name || "--" } 
                                                            
                                                          </TableCell>
                                                          <TableCell component="td">
                                                                                 {item.check_in}
                                                                               </TableCell>
                                     </TableRow>

                    {/* Expanded Row */}
                    {expandedRows[index] && (
                      <TableRow>
                        <TableCell component="td" colSpan={3}>
                          <div className="row">

                            {
                            
                 
                 
                 
                 (
  selectedType === "allow-hotel-activity"
    ? [
        { label: "Room Type", value: item?.room_type_name || "--", colClass: "col-6" },
        { label: "No Of Days", value: item?.days || "--", colClass: "col-6" },
        { label: "Hotel Name", value: item?.hotel_name || "--", colClass: "col-12" },
      ]
    : selectedType === "actual-hotel-activity"
    ? [
        { label: "Room Type", value: item?.room_type_name || "--", colClass: "col-6" },
        { label: "Check In Date", value: item?.check_in || "--", colClass: "col-6" },
        { label: "No Of Days", value: item?.days || "--", colClass: "col-6" },
        { label: "Hotel Name", value: item?.hotel_name || "--", colClass: "col-12" },
      ]
    : []
)
                 
                 
                 
                 
                            .map((field, idx) => (
                              <div
                                key={idx}
                                className={`${field.colClass} d-flex flex-column mb-3`}
                              >
                                <b>{field.label}:</b> {field.value}
                              </div>
                            ))}

                            {Array.isArray(item["1"]) && (
                              <div className="col-6 d-flex flex-column mb-3">
                                <label htmlFor={`action-select-${index}`}>
                                  <b>Action:</b>
                                </label>

                                <select
                                  id={`action-select-${index}`}
                                  className="form-select py-3"
                                  onChange={(e) => handleNavigate(e, index)}
                                  value={selectedActions[index] || ""}
                                >
                                  <option value="" disabled>
                                    -- Select an Action --
                                  </option>
                                  {item["1"].map((opt, idx) => (
                                    <option
                                      key={idx}
                                      value={
                                        Array.isArray(opt.action)
                                          ? opt.action.join(",")
                                          : (opt.action || "")
                                      }
                                    >
                                      {opt.label || "--"}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))
              )}
          </TableBody>
        </Table>
      </Paper>

     
    </div>

  </> : showTable !== null &&  selectedType?.toLowerCase().split("-").includes("transport") ? 
  <>

    <div style={{ marginBottom: "50px" }}>
      <Paper sx={{ padding: "0px 20px" }}>
        <Table
          id="example"
          className="table table-striped dt-responsive nowrap table-display w-100"
        >
          {/* Table Head */}
          <TableHead>
            <TableRow>
              <TableCell component="th" sx={{ fontWeight: "bold" }}>
                Voucher
              </TableCell>

              {  selectedType === "allow-transport-activity" ?
              

              <TableCell component="th" sx={{ fontWeight: "bold" }}>

                Transport 
              </TableCell> :
              <TableCell component="th" sx={{ fontWeight: "bold" }}>
 Travel Date
              
              </TableCell>
              }


              <TableCell component="th" sx={{ fontWeight: "bold" }}>
                Travel Type
              </TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {Loading ? (
              <TableRow>
                <TableCell
                  colSpan={3}
                  align="center"
                  style={{ height: "35vh" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <BounceLoader className="BouncingLoader" />
                  </div>
                </TableCell>
              </TableRow>
            ) : tableData.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={3}
                  align="center"
                  style={{ height: "25vh" }}
                >
                  <h3 className="pt-5">No data found</h3>
                </TableCell>
              </TableRow>
            ) : (
              tableData?.map((item, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell
                      component="td"
                      sx={{ cursor: "pointer" }}
                      onClick={() => toggleExpansion(index)}
                    >
                      {item.voucher_id}
                    </TableCell>
                    <TableCell component="td">
                      {

                       selectedType === "allow-hotel-activity" ? 
                        item.transport_type_name :
                       
                      item.travel_date
                      } 
                    </TableCell>
                    <TableCell component="td">
                      {item.travel_type || "--"}
                    </TableCell>
                  </TableRow>

                  {/* Expanded Row */}
                  {expandedRows[index] && (
                    <TableRow>
                      <TableCell component="td" colSpan={3}>
                        <div className="row">

                          {[
                          
                            {
                              label: "Voucher Id",
                              value: item.voucher_id || "--",
                              colClass: "col-6",
                            },
                            {
                              label: "Travel Type",
                              value: item.travel_type || "--",
                              colClass: "col-6",
                            },
                            {
                              label: "No Of Seats",
                              value: item.no_of_seats || "--",
                              colClass: "col-6",
                            },
                            {
                              label: "Vehicle No",
                              value: item.vehicle_no || "--",
                              colClass: "col-6",
                            },
                            {
                              label: "Vehicle Company",
                              value: item.vehicle_company || "--",
                              colClass: "col-12",
                            },
                          ].map((field, idx) => (
                            <div
                              key={idx}
                              className={`${field.colClass} d-flex flex-column mb-3`}
                            >
                              <b>{field.label}:</b> {field.value}
                            </div>
                          ))}

                          {Array.isArray(item["0"]) && (
                            <div className="col-6 d-flex flex-column mb-3">
                              <label htmlFor={`action-select-${index}`}>
                                <b>Action</b>
                              </label>
                              <select
                                id={`action-select-${index}`}
                                className="form-select py-3"
                                onChange={(e) =>
                                  handleNavigate(e, index)
                                }
                                value={selectedActions[index] || ""}
                              >
                                <option value="" disabled>
                                  -- Select an Action --
                                </option>
                                {item["0"].map((opt, idx) => (
                                  <option
                                    key={idx}
                                    value={
                                      Array.isArray(opt.action)
                                        ? opt.action.join(",")
                                        : (opt.action || "")
                                    }
                                  >
                                    {opt.label || "--"}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

     

    </div>

  </> : <></>
}


       < AllowHotalModal
        open={open}
        setOpen={setOpen}
        sendDataToModal={sendDataToModal}   
        setSendDataToModal={setSendDataToModal}
         setFormVisible={setFormVisible}
        setSelectedActions={setSelectedActions}
      />

      <AllowTransportReturnModal
        open={openReturnVoucher}
        setOpen={setOpenReturnVoucher}
        sendDataToModal={sendDataToModal}
      /> 








                </div>
              </div>
            </div>
            <div>
              <BottomNavigationBar />
            </div>
          </div>
        </MDBContainer>
      </div>
    </>
  );
};

export default SingleAllowTransport;
